import { useParams } from "react-router-dom";
import { StaffFirmProfileForm } from "./StaffFirmProfileForm";

export function FirmProfileDetail() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <p role="alert">Missing firm profile id.</p>;
  }
  return <StaffFirmProfileForm mode="edit" id={id} />;
}

export default FirmProfileDetail;
